import {createStore} from './store';
import {createRouter} from './router';

import Vue from 'vue';
import Page from '../Page.vue';
import PublicationAreasSelect from './PublicationAreasSelect.vue';
import PublicationsPagination from './PublicationsPagination.vue';

const publicationsListQuery = '#v-publications-war';
const publicationsListEl = document.querySelector(publicationsListQuery);
if(publicationsListEl) {
	const store = createStore({
		baseUrl: window.LOCALE ? `/${window.LOCALE}/` : '/',
		publicationsListHtml: publicationsListEl.innerHTML,
		legalAreasList: window.LEGAL_AREAS,
		pageCount: window.PAGE_COUNT,
		isForSoldier: true
	});
	const router = createRouter(store);	
	var vm = new Vue({
		render: h => h(Page),
		router,
		store
	}).$mount(publicationsListQuery);	

	if (document.querySelector('.custom-select')) {
		var selectVm = new Vue({
			render: h => h(PublicationAreasSelect),
			router,
			store
		}).$mount('.custom-select');
	}

	var paginationVM = new Vue({
		render: h => h(PublicationsPagination),
		router,
		store
	}).$mount('#publications-pagination');	

	const noResults = document.querySelector('.publications-section__no-results');
	store.watch(state => state.pageCount, pageCount => {
		if(pageCount) noResults.classList.remove('publications-section__no-results--active');
		else noResults.classList.add('publications-section__no-results--active');
	});
}



